import React, { Fragment, useEffect, useState } from "react"
import { Popover, Transition } from "@headlessui/react"
import { Bars3Icon as MenuIcon } from "@heroicons/react/24/outline"
import { XMarkIcon as XIcon } from "@heroicons/react/24/outline"
import { ChevronDownIcon } from "@heroicons/react/24/solid"
import Logo from "../../images/logos/logo.js"
import Icon from "../../images/icons/icons"
import { logout, isAuthenticated } from "../../utils/auth"
import Link from "../../utils/link"
import { navigate } from "gatsby"

const solutions = [
	{
		name: "Education",
		href: "/education",
		description:
			"Safeguard students by monitoring access to self-harm, extremist or inappropriate content",
		icon: "DuoGraduationHat",
	},
	{
		name: "Business",
		href: "/business",
		description: "Increase workplace productivity with management friendly internet usage reports",
		icon: "DuoBriefcase",
	},
	{
		name: "Public Sector",
		href: "/publicsector",
		description: "Monitor high-risk incidents, ensure compliance, and improve productivity",
		icon: "DuoGovernmentBuilding",
	},
	{
		name: "IT",
		href: "/it",
		description: "Get visibility into your network and troubleshoot issues faster",
		icon: "DuoShieldCheck",
	},
]

const company = [
	{
		name: "About Us",
		href: "/about",
		description: "",
		icon: "DuoUserGroup",
	},
	{
		name: "Customers",
		href: "/customers",
		description: "",
		icon: "DuoOffice",
	},
	{
		name: "Partners",
		href: "/partners",
		description: "",
		icon: "DuoGlobeCertified",
	},
	{
		name: "Contact",
		href: "/contact",
		description: "",
		icon: "DuoSupport2",
	},
	{
		name: "Blog",
		href: "/blog",
		description: "",
		icon: "DuoBlog",
	},
]

const myAccount = [
	{
		id: 1,
		name: "My details",
		href: "/account/my-details",
		icon: "DuoUserAccount",
	},
	{
		id: 2,
		name: "Downloads",
		href: "/account/downloads",
		icon: "DuoDownloadAlt",
	},
	{
		id: 3,
		name: "Installation guides",
		href: "/account/installs",
		icon: "DuoKnowledge",
	},
	{
		id: 4,
		name: "Log out",
		href: "/account/logout",
		icon: "DuoLogout",
	},
]

const products = [
	{
		GroupName: "Fastvue Reporter",
		Products: [
			{ id: 1, name: "Overview", href: "/reporter-overview" },
			{ id: 2, name: "Features", href: "/reporter-features" },
			{ id: 3, name: "Reporter for Barracuda", href: "/barracuda" },
			{ id: 4, name: "Reporter for Cisco Firepower", href: "/ciscofirepower" },
			{ id: 4, name: "Reporter for Cisco Umbrella SIG", href: "/ciscoumbrella" },
			{ id: 5, name: "Reporter for ContentKeeper", href: "/contentkeeper" },
			{ id: 6, name: "Reporter for FortiGate", href: "/fortinet" },
			{
				id: 7,
				name: "Reporter for Palo Alto Networks",
				href: "/paloaltonetworks",
			},
			{ id: 8, name: "Reporter for SonicWall", href: "/sonicwall" },
			{ id: 9, name: "Reporter for Sophos Firewall", href: "/sophos" },
			{
				id: 10,
				name: "Reporter for Sophos Web Appliance",
				href: "/sophos/swa",
			},
			{ id: 11, name: "Reporter for TMG", href: "/tmgreporter" },
			{ id: 12, name: "Reporter for WatchGuard", href: "/watchguard" },
		],
	},
	{
		GroupName: "Other Products",
		Products: [
			{ id: 1, name: "WebSpy Vantage", href: "https://www.webspy.com" },
			{ id: 2, name: "Fastvue Syslog", href: "/syslog" },
		],
	},
]

const supports = [
	{
		GroupName: "Fastvue Reporter",
		Products: [
			{
				id: 1,
				name: "Reporter for Barracuda",
				href: "https://kb.fastvue.co/barracuda",
			},
			{
				id: 2,
				name: "Reporter for Cisco Firepower",
				href: "https://kb.fastvue.co/ciscofirepower",
			},
			{
				id: 2,
				name: "Reporter for Cisco Umbrella SIG",
				href: "https://kb.fastvue.co/ciscoumbrella",
			},
			{
				id: 3,
				name: "Reporter for ContentKeeper",
				href: "https://kb.fastvue.co/contentkeeper",
			},
			{
				id: 4,
				name: "Reporter for FortiGate",
				href: "https://kb.fastvue.co/fortigate",
			},
			{
				id: 5,
				name: "Reporter for Palo Alto Networks",
				href: "https://kb.fastvue.co/paloalto",
			},
			{
				id: 6,
				name: "Reporter for SonicWall",
				href: "https://kb.fastvue.co/sonicwall",
			},
			{
				id: 7,
				name: "Reporter for Sophos Firewall",
				href: "https://kb.fastvue.co/sophos",
			},
			{
				id: 8,
				name: "Reporter for Sophos Web Appliance",
				href: "https://kb.fastvue.co/sophos/swa",
			},
			{
				id: 9,
				name: "Reporter for TMG",
				href: "https://kb.fastvue.co/tmgreporter",
			},
			{
				id: 10,
				name: "Reporter for WatchGuard",
				href: "https://kb.fastvue.co/watchguard",
			},
		],
	},
	{
		GroupName: "Other Products",
		Products: [
			{ id: 10, name: "WebSpy Vantage", href: "https://kb.webspy.com" },
			{
				id: 11,
				name: "Fastvue Syslog",
				href: "https://kb.fastvue.co/syslog",
			},
		],
	},
]

function classNames(...classes) {
	return classes.filter(Boolean).join(" ")
}

const PopOverPanel = React.forwardRef((props, ref) => {
	const navigateToPage = (to) => {
		// props.close(true);
		navigate(to)
	}

	return (
		<>
			<Popover.Panel
				static
				className="origin-top-right absolute right-0 mt-2 w-auto transform z-10 px-2 shadow-lg bg-white ring-1 sm:px-0 ring-black ring-opacity-5 divide-y divide-gray-100 focus:outline-none"
				ref={ref}
			>
				<div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden">
					<div className="relative grid gap-6 bg-white px-5 py-6 sm:gap-8 sm:p-8 whitespace-nowrap">
						{props &&
							props.items.map((item, id) =>
								item.name === "Log out" ? (
									<div
										className="-m-3 p-2 flex cursor-pointer items-start rounded-lg hover:bg-gray-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary-500"
										onClick={() => logout()}
										key={id}
										role="menuitem"
										tabIndex={0}
										onKeyDown={() => logout()}
									>
										<Icon
											iconName={item.icon}
											className="flex-shrink-0 h-6 w-6 text-primary-600"
											aria-hidden="true"
										/>
										<div className="ml-4">
											<span className="text-base font-medium text-gray-900">{item.name}</span>
										</div>
									</div>
								) : (
									<div
										key={item.name}
										tabIndex={0}
										role="button"
										onClick={(e) => {
											e.stopPropagation()
											navigateToPage(item.href)
										}}
										onKeyDown={(e) => {
											e.stopPropagation()
											navigateToPage(item.href)
										}}
										className="-m-3 p-2 flex items-start rounded-lg hover:bg-gray-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary-500 cursor-pointer"
									>
										<Icon
											iconName={item.icon}
											className="flex-shrink-0 h-6 w-6 text-primary-600"
											aria-hidden="true"
										/>
										<div className="ml-4">
											<span className="text-base font-medium text-gray-900">{item.name}</span>
										</div>
									</div>
								)
							)}
					</div>
				</div>
			</Popover.Panel>
		</>
	)
})

const PopoverPanelProductGroups = React.forwardRef((props, ref) => {
	const navigateToPage = (to) => {
		// props.close(true);
		navigate(to)
	}

	return (
		<>
			<Popover.Panel
				static
				className={`absolute z-20 mt-3 px-2 w-screen max-w-md sm:px-0 lg:max-w-3xl ${
					props.side === "left" ? "left-0" : "right-0"
				}`}
				ref={ref}
			>
				<div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden">
					<div className="relative bg-white px-5 py-5 sm:gap-8 sm:p-8 ">
						{props &&
							props.items &&
							props.items.map((item, index, array) => (
								<div key={item.GroupName}>
									<div className="py-2 px-4">
										<h3 className="text-sm tracking-wide font-medium text-primary-500 uppercase">
											{item.GroupName}
										</h3>
									</div>
									<div className={classNames("relative mt-4 mb-5 grid grid-cols-2 gap-5")}>
										{item.Products.map((product) =>
											product.href.startsWith("http://") ||
											product.href.startsWith("https://") ||
											product.href.startsWith("mailto:") ? (
												<Link
													key={product.name}
													to={product.href}
													className="-m-3 p-3 flex items-start rounded-lg hover:bg-gray-100 transition ease-in-out duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary-500 cursor-pointer"
												>
													<div className="ml-4">
														<span className="text-base font-medium text-gray-900">
															{product.name}
														</span>
													</div>
												</Link>
											) : (
												<div
													key={product.name}
													tabIndex={0}
													role="button"
													onClick={(e) => {
														e.stopPropagation()
														navigateToPage(product.href)
													}}
													onKeyDown={(e) => {
														e.stopPropagation()
														navigateToPage(product.href)
													}}
													className="-m-3 p-3 flex items-start rounded-lg hover:bg-gray-100 transition ease-in-out duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary-500 cursor-pointer"
												>
													<div className="ml-4">
														<span className="text-base font-medium text-gray-900">
															{product.name}
														</span>
													</div>
												</div>
											)
										)}
									</div>
									{array.length - 1 !== index && (
										<div className="my-5 w-full border-t border-gray-200" />
									)}
								</div>
							))}
					</div>
				</div>
			</Popover.Panel>
		</>
	)
})

export default function NavBar() {
	const [isShowing, setIsShowing] = useState(false)
	const [currentMenu, setCurrentMenu] = useState(() => {
		return "products"
	})
	const [isShowingMobile, setIsShowingMobile] = useState(false)
	const [show, setShow] = useState(true)
	// const isDesktop = useMatchMedia("(min-width: 768px)");

	useEffect(() => {
		let oldValue = 0
		let newValue = 0

		window.addEventListener("scroll", function (e) {
			// Get the new Value
			newValue = window.pageYOffset

			//Subtract the two and conclude
			if (oldValue - newValue < 0) {
				setShow(false)
			} else if (oldValue - newValue > 0) {
				setShow(true)
			}

			// Update the old value
			oldValue = newValue
		})
	}, [])

	const toggleMenu = (newMenu) => {
		setCurrentMenu(newMenu)
		setIsShowing((isShowing) => !isShowing)
	}

	const openMenuMobile = () => {
		setIsShowingMobile((isShowingMobile) => !isShowingMobile)
		!isShowingMobile && setIsShowing(false)
	}

	const navigateToPage = (to) => {
		openMenuMobile()
		navigate(to)
	}

	return (
		<>
			<nav className={`nav-container z-20 ${show && "sticky-top-nav"}`}>
				<Popover className="xl:container xl:mx-auto">
					{({ open }) => (
						<>
							<div className="max-w-7xl lg:max-w-full mx-auto px-4 sm:px-6">
								<div className="flex justify-between items-center py-6 md:justify-start md:space-x-4">
									<div className="-mr-2 -my-2 order-2 md:order-1 md:flex-1 lg:hidden ">
										<button
											as="button"
											onClick={(e) => {
												e.stopPropagation()
												openMenuMobile()
											}}
											className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-500"
										>
											<span className="sr-only">Open menu</span>
											<MenuIcon
												className="h-6 w-6"
												aria-hidden="true"
											/>
										</button>
									</div>
									<div className="flex order-1 md:order-2 lg:order-1 justify-start md:justify-center lg:justify-start lg:w-0 md:flex-1">
										<Link
											to="/"
											className=" rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary-500"
										>
											<span className="sr-only">Fastvue</span>
											<Logo className="h-7" />
										</Link>
									</div>
									<Popover.Group
										as="nav"
										className="hidden lg:flex lg:order-2 space-x-6 align-middle"
									>
										<Popover className="relative">
											{({ open, close }) => (
												<>
													<Popover.Button
														className={classNames(
															open ? "text-gray-900" : "text-gray-500",
															"group bg-white rounded-md inline-flex px-3.5 py-2 items-center text-base font-medium hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
														)}
													>
														<span>Products</span>
														<ChevronDownIcon
															className={classNames(
																open ? "text-gray-600" : "text-gray-400",
																"ml-2 h-5 w-5 group-hover:text-gray-500"
															)}
															aria-hidden="true"
														/>
													</Popover.Button>

													<Transition
														show={open}
														as={Fragment}
														enter="transition ease-out duration-300"
														enterFrom="opacity-0 translate-y-1"
														enterTo="opacity-100 translate-y-0"
														leave="transition ease-in duration-300"
														leaveFrom="opacity-100 translate-y-0"
														leaveTo="opacity-0 translate-y-1"
													>
														<PopoverPanelProductGroups
															items={products}
															side="left"
															close={close}
														/>
													</Transition>
												</>
											)}
										</Popover>

										<Popover className="relative">
											{({ open, close }) => (
												<>
													<Popover.Button
														className={classNames(
															open ? "text-gray-900" : "text-gray-500",
															"group bg-white rounded-md inline-flex items-center px-3.5 py-2 text-base font-medium hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
														)}
													>
														<span>Solutions</span>
														<ChevronDownIcon
															className={classNames(
																open ? "text-gray-600" : "text-gray-400",
																"ml-2 h-5 w-5 group-hover:text-gray-500"
															)}
															aria-hidden="true"
														/>
													</Popover.Button>

													<Transition
														show={open}
														as={Fragment}
														enter="transition ease-out duration-200"
														enterFrom="opacity-0 translate-y-1"
														enterTo="opacity-100 translate-y-0"
														leave="transition ease-in duration-150"
														leaveFrom="opacity-100 translate-y-0"
														leaveTo="opacity-0 translate-y-1"
													>
														<Popover.Panel
															static
															className="absolute -ml-4 mt-3 transform z-10 px-2 w-screen max-w-md sm:px-0 lg:ml-0 lg:left-1/2 lg:-translate-x-1/2"
														>
															<div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden">
																<div className="relative grid gap-6 bg-white px-5 py-6 sm:gap-8 sm:p-8">
																	{solutions &&
																		solutions.map((item, id) => (
																			<div
																				key={id}
																				tabIndex={0}
																				role="button"
																				onClick={(e) => {
																					// close(true)
																					e.stopPropagation()
																					navigate(item.href)
																				}}
																				onKeyDown={(e) => {
																					// close(true)
																					e.stopPropagation()
																					navigate(item.href)
																				}}
																				className="-m-3 p-3 flex items-start rounded-lg hover:bg-gray-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary-500"
																			>
																				<Icon
																					iconName={item.icon}
																					className="flex-shrink-0 h-6 w-6 text-primary-600"
																				/>
																				<div className="ml-4">
																					<div className="text-base font-medium text-gray-900">
																						{item.name}
																					</div>
																					<span className="mt-1 text-sm text-gray-500">
																						{item.description}
																					</span>
																				</div>
																			</div>
																		))}
																</div>
															</div>
														</Popover.Panel>
													</Transition>
												</>
											)}
										</Popover>

										<Popover className="relative">
											{({ open, close }) => (
												<>
													<Popover.Button
														className={classNames(
															open ? "text-gray-900" : "text-gray-500",
															"group bg-white rounded-md inline-flex items-center px-3.5 py-2 text-base font-medium hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
														)}
													>
														<span>Company</span>
														<ChevronDownIcon
															className={classNames(
																open ? "text-gray-600" : "text-gray-400",
																"ml-2 h-5 w-5 group-hover:text-gray-500"
															)}
															aria-hidden="true"
														/>
													</Popover.Button>

													<Transition
														show={open}
														as={Fragment}
														enter="transition ease-out duration-200"
														enterFrom="opacity-0 translate-y-1"
														enterTo="opacity-100 translate-y-0"
														leave="transition ease-in duration-150"
														leaveFrom="opacity-100 translate-y-0"
														leaveTo="opacity-0 translate-y-1"
													>
														<PopOverPanel
															items={company}
															close={() => close}
														/>
													</Transition>
												</>
											)}
										</Popover>

										<Popover className="relative">
											{({ open, close }) => (
												<>
													<Popover.Button
														className={classNames(
															open ? "text-gray-900" : "text-gray-500",
															"group bg-white rounded-md inline-flex px-3.5 py-2 items-center text-base font-medium hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
														)}
													>
														<span>Support</span>
														<ChevronDownIcon
															className={classNames(
																open ? "text-gray-600" : "text-gray-400",
																"ml-2 h-5 w-5 group-hover:text-gray-500"
															)}
															aria-hidden="true"
														/>
													</Popover.Button>

													<Transition
														show={open}
														as={Fragment}
														enter="transition ease-out duration-200"
														enterFrom="opacity-0 translate-y-1"
														enterTo="opacity-100 translate-y-0"
														leave="transition ease-in duration-150"
														leaveFrom="opacity-100 translate-y-0"
														leaveTo="opacity-0 translate-y-1"
													>
														<PopoverPanelProductGroups
															items={supports}
															side="right"
															close={close}
														></PopoverPanelProductGroups>
													</Transition>
												</>
											)}
										</Popover>
									</Popover.Group>
									{isAuthenticated() ? (
										<>
											<div className="hidden md:flex md:order-2 items-center justify-end md:flex-1 lg:w-0">
												<Popover className="relative">
													{({ open, close }) => (
														<>
															<Popover.Button
																className={classNames(
																	open ? "text-gray-900" : "text-gray-500",
																	"group bg-white border border-solid border-gray-300 px-3.5 py-2 inline-flex items-center text-base font-medium hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
																)}
															>
																<span>My Account</span>
																<ChevronDownIcon
																	className={classNames(
																		open ? "text-gray-600" : "text-gray-400",
																		"ml-2 h-5 w-5 group-hover:text-gray-500"
																	)}
																	aria-hidden="true"
																/>
															</Popover.Button>

															<Transition
																show={open}
																as={Fragment}
																enter="transition ease-out duration-200"
																enterFrom="opacity-0 translate-y-1"
																enterTo="opacity-100 translate-y-0"
																leave="transition ease-in duration-150"
																leaveFrom="opacity-100 translate-y-0"
																leaveTo="opacity-0 translate-y-1"
															>
																<PopOverPanel
																	items={myAccount}
																	className={classNames("bg-primary-300")}
																	close={close}
																/>
															</Transition>
														</>
													)}
												</Popover>
											</div>
										</>
									) : (
										<>
											<div className="hidden md:flex md:order-2 items-center justify-end md:flex-1 lg:w-0">
												<Link
													to={"/login"}
													className="text-base font-medium text-gray-500 hover:text-gray-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary-500"
												>
													Log in
												</Link>
												<Link
													to="/signup"
													className="btn btn-primary ml-8 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary-500"
												>
													Try for free
												</Link>
											</div>
										</>
									)}
								</div>
							</div>

							{/* Smaller device */}
							<Transition
								show={isShowingMobile}
								as={Fragment}
								enter="duration-300 ease-out"
								enterFrom="translate-x-full"
								enterTo="translate-x-0"
								leave="duration-300 ease-in"
								leaveFrom="translate-x-0"
								leaveTo="translate-x-full"
							>
								<Popover.Panel
									focus
									static
									className="fixed top-0 right-0 w-full h-full z-10 transition transform origin-right lg:hidden"
								>
									<>
										<div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity h-screen"></div>
										<div className="shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y-2 divide-gray-50 transform transition-all">
											<div className="pt-5 pb-6 px-5">
												<div className="flex items-center justify-between">
													<div>
														<Link to="/">
															<span className="sr-only">Fastvue</span>
															<Logo className="h-7" />
														</Link>
													</div>
													<div className="-mr-2">
														<button
															as="button"
															onClick={(e) => {
																e.stopPropagation()
																openMenuMobile()
															}}
															className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-500"
														>
															<span className="sr-only">Close menu</span>
															<XIcon
																className="h-6 w-6"
																aria-hidden="true"
															/>
														</button>
													</div>
												</div>
												<div className="min-h-[29rem]">
													<Transition
														show={isShowing}
														as={Fragment}
														enter="transition duration-300 transform"
														enterFrom="translate-x-full"
														enterTo="translate-x-0"
														leave="transition ease-in-out duration-300 transform"
														leaveFrom="translate-x-0"
														leaveTo="translate-x-full"
													>
														{() => {
															switch (currentMenu) {
																case "products":
																	return (
																		<div className="px-4 bg-white absolute inset-x-0 z-10 transition transform overflow-y-scroll h-full">
																			<div>
																				<button
																					className="py-6 flex items-start items-center w-full"
																					onClick={(e) => {
																						e.stopPropagation()
																						toggleMenu("products")
																					}}
																					type="button"
																				>
																					<span className="inline-block">
																						<Icon
																							iconName="ArrowLeft"
																							className="flex-shrink-0 h-6 w-6 fill-current text-gray-400"
																							aria-hidden="true"
																						/>
																					</span>
																					<span className="ml-3 text-lg font-medium text-gray-900">
																						Products
																					</span>
																				</button>
																			</div>
																			{products.map((item, index, array) => (
																				<div key={item.GroupName}>
																					<div
																						className="py-2"
																						key={item.GroupName}
																					>
																						<h3 className="text-sm tracking-wide font-medium text-primary-500 uppercase">
																							{item.GroupName}
																						</h3>
																					</div>
																					<div
																						className={`mb-4 grid lg:grid-flow-col lg:grid-cols-2`}
																					>
																						{item.Products.map((product) => (
																							<div
																								key={product.name}
																								tabIndex={0}
																								role="button"
																								className="py-3 flex items-start"
																								onClick={(e) => {
																									e.stopPropagation()
																									navigateToPage(product.href)
																								}}
																								onKeyDown={(e) => {
																									e.stopPropagation()
																									navigateToPage(product.href)
																								}}
																							>
																								<div className="">
																									<span className="text-base font-medium text-gray-900">
																										{product.name}
																									</span>
																								</div>
																							</div>
																						))}
																					</div>
																					{array.length - 1 !== index && (
																						<div className="my-5 w-full border-t border-gray-200" />
																					)}
																				</div>
																			))}
																		</div>
																	)
																case "solutions":
																	return (
																		<div className="px-4 bg-white absolute inset-x-0 z-10 transition transform">
																			<div>
																				<button
																					className="py-6 flex items-start items-center w-full"
																					onClick={(e) => {
																						e.stopPropagation()
																						toggleMenu("solutions")
																					}}
																					type="button"
																				>
																					<span className="inline-block">
																						<Icon
																							iconName="ArrowLeft"
																							className="flex-shrink-0 h-6 w-6 fill-current text-gray-400"
																							aria-hidden="true"
																						/>
																					</span>
																					<span className="ml-3 text-lg font-medium text-gray-900">
																						Solutions
																					</span>
																				</button>
																			</div>
																			{solutions.map((item) => (
																				<div
																					key={item.name}
																					tabIndex={0}
																					className="py-3 flex items-start"
																					role="button"
																					onClick={(e) => {
																						e.stopPropagation()
																						navigateToPage(item.href)
																					}}
																					onKeyDown={(e) => {
																						e.stopPropagation()
																						navigateToPage(item.href)
																					}}
																				>
																					<span className="text-base font-medium text-gray-900">
																						{item.name}
																					</span>
																				</div>
																			))}
																		</div>
																	)

																case "company":
																	return (
																		<div className="px-4 bg-white absolute inset-x-0 z-10 transition transform">
																			<div>
																				<button
																					className="py-6 flex items-start items-center w-full"
																					onClick={() => toggleMenu("company")}
																					type="button"
																				>
																					<span className="inline-block">
																						<Icon
																							iconName="ArrowLeft"
																							className="flex-shrink-0 h-6 w-6 fill-current text-gray-400"
																							aria-hidden="true"
																						/>
																					</span>
																					<span className="ml-3 text-lg font-medium text-gray-900">
																						Company
																					</span>
																				</button>
																			</div>
																			{company.map((item) => (
																				<div
																					key={item.name}
																					tabIndex={0}
																					className="py-3 flex items-start"
																					role="button"
																					onClick={(e) => {
																						e.stopPropagation()
																						navigateToPage(item.href)
																					}}
																					onKeyDown={(e) => {
																						e.stopPropagation()
																						navigateToPage(item.href)
																					}}
																				>
																					<span className="text-base font-medium text-gray-900">
																						{item.name}
																					</span>
																				</div>
																			))}
																		</div>
																	)

																case "myAccount":
																	return (
																		<div className="px-4 bg-white absolute inset-x-0 z-10 transition transform">
																			<div>
																				<button
																					className="py-6 flex items-start items-center w-full"
																					onClick={() => toggleMenu("myAccount")}
																					type="button"
																				>
																					<span className="inline-block">
																						<Icon
																							iconName="ArrowLeft"
																							className="flex-shrink-0 h-6 w-6 fill-current text-gray-400"
																							aria-hidden="true"
																						/>
																					</span>
																					<span className="ml-3 text-lg font-medium text-gray-900">
																						My Account
																					</span>
																				</button>
																			</div>
																			{myAccount.map((item) =>
																				item.name === "Log out" ? (
																					<div
																						onClick={() => {
																							logout()
																						}}
																						className="py-3 flex items-start cursor-pointer"
																						key={item.name}
																						role="button"
																						tabIndex={0}
																						onKeyDown={() => {
																							logout()
																						}}
																					>
																						<span className="text-base font-medium text-gray-900">
																							{item.name}
																						</span>
																					</div>
																				) : (
																					<a
																						key={item.name}
																						href={item.href}
																						className="py-3 flex items-start"
																					>
																						<span className="text-base font-medium text-gray-900">
																							{item.name}
																						</span>
																					</a>
																				)
																			)}
																		</div>
																	)

																case "supports":
																	return (
																		<div className="px-4 bg-white absolute inset-x-0 z-10 transition transform overflow-y-scroll h-full">
																			<div>
																				<button
																					className="py-6 flex items-start items-center w-full"
																					onClick={(e) => {
																						e.stopPropagation()
																						toggleMenu("supports")
																					}}
																					type="button"
																				>
																					<span className="inline-block">
																						<Icon
																							iconName="ArrowLeft"
																							className="flex-shrink-0 h-6 w-6 fill-current text-gray-400"
																							aria-hidden="true"
																						/>
																					</span>
																					<span className="ml-3 text-lg font-medium text-gray-900">
																						Support
																					</span>
																				</button>
																			</div>
																			{supports.map((item, index, array) => (
																				<div key={item.GroupName}>
																					<div
																						className="py-2"
																						key={item.GroupName}
																					>
																						<h3 className="text-sm tracking-wide font-medium text-primary-500 uppercase">
																							{item.GroupName}
																						</h3>
																					</div>
																					<div
																						className={`mb-4 grid lg:grid-flow-col lg:grid-cols-2 lg:grid-rows-${Math.round(
																							item.Products.length / 2
																						)}`}
																					>
																						{item.Products.map((product) => (
																							<div
																								key={product.name}
																								role="button"
																								tabIndex={0}
																								className="py-3 flex items-start"
																								onClick={(e) => {
																									e.stopPropagation()
																									navigateToPage(product.href)
																								}}
																								onKeyDown={(e) => {
																									e.stopPropagation()
																									navigateToPage(product.href)
																								}}
																							>
																								<div className="">
																									<span className="text-base font-medium text-gray-900">
																										{product.name}
																									</span>
																								</div>
																							</div>
																						))}
																					</div>
																					{array.length - 1 !== index && (
																						<div className="my-5 w-full border-t border-gray-200" />
																					)}
																				</div>
																			))}
																		</div>
																	)

																default:
																	return ""
															}
														}}
													</Transition>
													<Transition
														show={!isShowing}
														as={Fragment}
														enter="transition duration-300 transform"
														enterFrom="-translate-x-full"
														enterTo="translate-x-0"
														leave="transition ease-in-out duration-300 transform"
														leaveFrom="translate-x-0"
														leaveTo="-translate-x-full"
													>
														<div className="w-100">
															<nav className="grid">
																<button
																	className="inline-block items-center py-6 text-lg text-left font-medium text-gray-900 hover:text-gray-700 w-full"
																	onClick={() => toggleMenu("products")}
																	type="button"
																>
																	Products
																	<span className="inline-block align-middle float-right md:float-none md:ml-4">
																		<Icon
																			iconName="ArrowRight"
																			className="flex-shrink-0 h-6 w-6 fill-current text-gray-400"
																			aria-hidden="true"
																		/>
																	</span>
																</button>
																<button
																	className="inline-block items-center py-6 text-lg text-left font-medium text-gray-900 hover:text-gray-700"
																	onClick={() => toggleMenu("solutions")}
																	type="button"
																>
																	Solutions
																	<span className="inline-block align-middle float-right md:float-none md:ml-4">
																		<Icon
																			iconName="ArrowRight"
																			className="flex-shrink-0 h-6 w-6 fill-current text-gray-400"
																			aria-hidden="true"
																		/>
																	</span>
																</button>
																<button
																	className="inline-block items-center py-6 text-lg text-left font-medium text-gray-900 hover:text-gray-700"
																	onClick={() => toggleMenu("company")}
																	type="button"
																>
																	Company
																	<span className="inline-block align-middle float-right md:float-none md:ml-4">
																		<Icon
																			iconName="ArrowRight"
																			className="flex-shrink-0 h-6 w-6 fill-current text-gray-400"
																			aria-hidden="true"
																		/>
																	</span>
																</button>
																<button
																	className="inline-block items-center py-6 text-lg text-left font-medium text-gray-900 hover:text-gray-700"
																	onClick={() => toggleMenu("supports")}
																	type="button"
																>
																	Support
																	<span className="inline-block align-middle float-right md:float-none md:ml-4">
																		<Icon
																			iconName="ArrowRight"
																			className="flex-shrink-0 h-6 w-6 fill-current text-gray-400"
																			aria-hidden="true"
																		/>
																	</span>
																</button>
																{isAuthenticated() ? (
																	<button
																		className="inline-block items-center py-6 text-lg text-left font-medium text-gray-900 hover:text-gray-700"
																		onClick={() => toggleMenu("myAccount")}
																		type="button"
																	>
																		My Account
																		<span className="inline-block align-middle float-right md:float-none md:ml-4">
																			<Icon
																				iconName="ArrowRight"
																				className="flex-shrink-0 h-6 w-6 fill-current text-gray-400"
																				aria-hidden="true"
																			/>
																		</span>
																	</button>
																) : null}
															</nav>

															{isAuthenticated() ? null : (
																<>
																	<Link
																		to="/account/"
																		className="btn btn-primary btn-xl w-full mb-4 mt-10"
																	>
																		Try it free
																	</Link>
																	<Link
																		to="/login"
																		className="btn btn-xl btn-outline w-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary-500"
																	>
																		Log in
																	</Link>
																</>
															)}
														</div>
													</Transition>
												</div>
											</div>
										</div>
									</>
								</Popover.Panel>
							</Transition>
						</>
					)}
				</Popover>
			</nav>
		</>
	)
}
